import { Core, Decorative } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web/common/localization";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web/common/localization/localize";
import { AlertBanner } from "@faire/web/ui/AlertBanner";
import * as React from "react";

import { getBrand } from "@faire/retailer/serialized-data/getBrand";
import { useUserStore } from "@faire/retailer/stores/domain/UserStore";

export const FaireDirectBrandPreviewBanner = () => {
  const { strictLocalize } = useStrictLocalization();
  const { logOut } = useUserStore(["logOut"]);

  return (
    <AlertBanner
      color={Decorative.shade.orange}
      textColor={Core.text.inverse}
      message={strictLocalize(
        {
          defaultMessage: "Viewing this page as {brand}.",
          description: {
            text: "Banner shown on a Faire Direct page.",
          },
        },
        DEPRECATED_backwardsCompatibleValues({
          brand: getBrand()?.name,
        })
      )}
      alertAction={{
        text: strictLocalize({
          defaultMessage: "Sign Out",
        }),
        action: {
          onClick: () => {
            logOut();
          },
        },
      }}
    />
  );
};
